module.exports = __webpack_public_path__ + "img/electrical-appliance.56c9537c.svg";